// Centralised z-index scale.
// Pre-existing bottom navs use `z-[9999]` so the modal/overlay layer sits at
// 10000+. Keep these values in sync with `tailwind.config.js` / inline styles
// so future modals don't drift back into conflict with the bottom nav.

export const Z_INDICES = {
  bottomNav: 9999,
  modalOverlay: 10000,
  toast: 10100,
};

export default Z_INDICES;
